import { apiCall } from './generated/gqlClient';

const getGroups = async type => {
  const query = `
    query getGroups($type: String!) {
      getGroups(type: $type) {
        id
        providerId
        name
        color
        counter
      }
    }
  `;

  return apiCall({ query, variables: { type } });
};

const getMembershipGroups = () => getGroups('membership');

// Create / Update
const saveGroupApiRequest = async (name, type, color, id) => {
  const mutation = `
    mutation saveGroup($name: String!, $type: String!, $color: String!, $id: Int) {
      saveGroup(name: $name, type: $type, color: $color, id: $id) {
        success
        id
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { name, type, color, id } });
};

const deleteGroupApiRequest = async id => {
  const mutation = `
    mutation deleteGroup($id: Int!) {
      deleteGroup(id: $id) {
        success
        id
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { id } });
};

export { deleteGroupApiRequest, getGroups, getMembershipGroups, saveGroupApiRequest };
